export default {
  confirmDelete: {
    header: 'Potwierdź reset',
    message: 'Usunięcie tego parametru spowoduje, że parametr następnego zasobu wyższego poziomu zostanie zastosowany do {asset}.\nJeśli żaden z zasobów nadrzędnych nie definiuje parametru, zostanie użyta wartość domyślna.\n\nCzy na pewno chcesz Usunąć parametr \'{parameter}\' dla \'{asset}\'?',
  },
};
